import React, { useState } from 'react'
import ProductQuantity from '@molecules/ProductQuantity/ProductQuantity'
import PriceTag from './PriceTag'
import * as T from './CommerceBox.types'

const CommerceBoxXS = ({
  product,
  CTAButton,
  WishlistButton,
  innerRef,
  onAddToCart,
  showLowestPrice
}: T.CommerceBoxMDProps) => {
  const {
    id,
    price,
    c_basePrice,
    c_priceDiscounted,
    c_minSetPrice,
    currency,
    c_inventory,
    quantity = 1,
    c_basketLimit,
    c_isGiftcard = false,
    c_lastMonthPrice,
    c_lastMonthPriceCallback
  } = product
  const [selectedQuantity, setSelectedQuantity] = useState(quantity)
  const isOrderable = c_inventory?.orderable

  return (
    <div
      className='grid grid-cols-[150px_auto] items-center justify-items-center'
      ref={innerRef}
    >
      <div>
        <ProductQuantity
          productId={id}
          selectedQuantity={selectedQuantity}
          limit={c_basketLimit}
          disabled={!isOrderable || c_isGiftcard || !!product?.type?.set}
          onChange={(quantity) => setSelectedQuantity(quantity)}
          width={'w-32'}
        />
      </div>
      <div className='flex w-full items-center justify-between md:px-0'>
        <PriceTag
          className='w-[6.5rem] sm:w-28'
          discountPrice={c_priceDiscounted}
          c_basePrice={c_basePrice}
          price={c_minSetPrice || price}
          currency={currency}
          showLowestPrice={showLowestPrice}
          lastMonthPrice={c_lastMonthPrice}
          lastMonthPriceCallback={c_lastMonthPriceCallback}
        />
        <div className='mr-3 flex flex-row space-x-1 md:mr-0'>
          <div
            className={!isOrderable ? 'cursor-not-allowed' : 'cursor-pointer'}
            onClick={() => {
              if (onAddToCart && isOrderable) {
                onAddToCart(selectedQuantity || 1)
              }
            }}
          >
            {CTAButton}
          </div>
          {WishlistButton && WishlistButton}
        </div>
      </div>
    </div>
  )
}

export default CommerceBoxXS
